import { render, staticRenderFns } from "./PackageRenew.vue?vue&type=template&id=31ad6412&scoped=true"
import script from "./PackageRenew.vue?vue&type=script&lang=js"
export * from "./PackageRenew.vue?vue&type=script&lang=js"
import style0 from "./PackageRenew.vue?vue&type=style&index=0&id=31ad6412&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ad6412",
  null
  
)

export default component.exports